class AnnouncementBarComponent extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.announcement-bar-slider__track');
    this.slides = Array.from(this.querySelectorAll('.announcement-bar-slider__slide'));
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.track || this.slides.length < 2 || !this.prevButton || !this.nextButton) return;

    this.currentIndex = 0;
    this.autoplaySpeed = (parseFloat(this.dataset.autoplaySpeed) || 4) * 1000;

    this.prevButton.addEventListener('click', () => this.onArrowClick(-1));
    this.nextButton.addEventListener('click', () => this.onArrowClick(1));

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.play());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.play();
    });

    this.updateActiveSlide();
    this.play();
  }

  onArrowClick(direction) {
    this.goTo(this.currentIndex + direction);
    this.play();
  }

  goTo(index) {
    const total = this.slides.length;
    this.currentIndex = (index + total) % total;
    this.updateActiveSlide();
  }

  updateActiveSlide() {
    this.slides.forEach((slide, index) => {
      const isActive = index === this.currentIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
      const link = slide.querySelector('a');
      if (!link) return;
      if (isActive) {
        link.removeAttribute('tabindex');
      } else {
        link.setAttribute('tabindex', '-1');
      }
    });
  }

  play() {
    clearInterval(this.autoplay);
    this.autoplay = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
  }

  pause() {
    clearInterval(this.autoplay);
  }
}

customElements.define('announcement-bar-component', AnnouncementBarComponent);
